module.exports = __webpack_public_path__ + "img/parking-barcelona-port.8c75d415.png";